export const moviesData = [
  {
    id: 1,
    title: "流浪地球3",
    titleEn: "The Wandering Earth 3",
    category: "电影",
    subCategory: "科幻",
    year: 2027,
    region: "中国大陆",
    rating: 9.1,
    description: "太阳急速老化，持续膨胀，即将吞没整个太阳系。人类在地球表面建造了上万座行星发动机，驱动地球开启长达2500年的宇宙流浪之旅。在这漫长的旅程中，人类文明面临着前所未有的挑战与抉择，一群年轻的宇航员挺身而出，为人类的未来展开了一场惊心动魄的生死搏斗。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20space%20station%20and%20Earth%20engines%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20epic%20scale%2C%20film%20poster%20style%20with%20Chinese%20text%20space%2C%20clean%20background&width=600&height=800&seq=movie-01&orientation=portrait",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "沙溢", "宁理"],
    duration: "148分钟",
    views: 2580000,
    isHot: true,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 2,
    title: "满江红2",
    titleEn: "Full River Red 2",
    category: "电影",
    subCategory: "悬疑",
    year: 2026,
    region: "中国大陆",
    rating: 8.8,
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇命案牵出惊天阴谋，小兵张大与亲兵营副统领孙均裹挟其中，步步惊心。层层反转之间，忠义与权谋的较量在暗夜中展开，一曲满江红道尽家国情怀。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20poster%2C%20ancient%20Chinese%20courtyard%20at%20night%2C%20red%20lanterns%2C%20dramatic%20shadows%2C%20Song%20dynasty%20aesthetic%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20film%20poster%20style%2C%20clean%20dark%20background&width=600&height=800&seq=movie-02&orientation=portrait",
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译", "雷佳音", "岳云鹏"],
    duration: "159分钟",
    views: 1890000,
    isHot: true,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 3,
    title: "封神第二部",
    titleEn: "Creation of the Gods II",
    category: "电影",
    subCategory: "动作",
    year: 2025,
    region: "中国大陆",
    rating: 8.5,
    description: "殷商末年，纣王暴虐无道，天下大乱。姜子牙携封神榜下山，辅佐周武王伐纣。天地人三界纷争不断，神仙妖魔各显神通。一场关乎天下苍生命运的大战即将拉开帷幕，封神传奇再续新篇章。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%2C%20ancient%20Chinese%20warriors%20in%20epic%20battle%2C%20golden%20armor%2C%20mythical%20creatures%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-03&orientation=portrait",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适", "陈牧驰", "娜然"],
    duration: "150分钟",
    views: 1560000,
    isHot: true,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 4,
    title: "热辣滚烫",
    titleEn: "YOLO",
    category: "电影",
    subCategory: "喜剧",
    year: 2024,
    region: "中国大陆",
    rating: 8.2,
    description: "宅女杜乐莹毕业后一直宅在家中，依靠父母生活。一次偶然的机会，她接触到了拳击运动，从此人生发生了翻天覆地的变化。在拳击教练的帮助下，她不仅找到了人生的方向，还收获了友情和爱情，完成了一次华丽的蜕变。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20poster%2C%20young%20woman%20boxing%20in%20a%20gym%2C%20warm%20lighting%2C%20inspirational%20vibe%2C%20bright%20and%20energetic%20colors%2C%20film%20poster%20style%2C%20clean%20white%20background&width=600&height=800&seq=movie-04&orientation=portrait",
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐", "杨紫", "沙溢"],
    duration: "129分钟",
    views: 3200000,
    isHot: true,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 5,
    title: "孤注一掷",
    titleEn: "No More Bets",
    category: "电影",
    subCategory: "剧情",
    year: 2023,
    region: "中国大陆",
    rating: 8.6,
    description: "程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。在诈骗头目的威逼利诱下，他们被迫参与网络诈骗活动。为了逃离这个人间地狱，他们决定放手一搏，与犯罪分子展开了一场惊心动魄的较量。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20film%20poster%2C%20dark%20atmosphere%2C%20Southeast%20Asian%20setting%2C%20intense%20drama%2C%20shadows%20and%20neon%20lights%2C%20mysterious%20mood%2C%20film%20poster%20style%2C%20clean%20dark%20background&width=600&height=800&seq=movie-05&orientation=portrait",
    director: "申奥",
    actors: ["张艺兴", "金晨", "咏梅", "王传君", "王大陆"],
    duration: "130分钟",
    views: 4100000,
    isHot: true,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 6,
    title: "长安三万里",
    titleEn: "Chang An",
    category: "电影",
    subCategory: "动画",
    year: 2023,
    region: "中国大陆",
    rating: 8.9,
    description: "安史之乱爆发后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事，两位大诗人截然不同的人生轨迹在大唐盛世的历史洪流中交织，谱写出一曲荡气回肠的盛唐挽歌。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20poster%2C%20Tang%20dynasty%20aesthetic%2C%20traditional%20Chinese%20painting%20style%2C%20golden%20palace%20and%20poetry%2C%20elegant%20composition%2C%20warm%20golden%20tones%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-06&orientation=portrait",
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫", "吴俊全"],
    duration: "168分钟",
    views: 1950000,
    isHot: false,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 7,
    title: "熊出没·逆转时空",
    titleEn: "Boonie Bears: Time Twist",
    category: "电影",
    subCategory: "动画",
    year: 2024,
    region: "中国大陆",
    rating: 7.9,
    description: "光头强是一名普通程序员，却常梦见陌生的森林和两头熊。一次偶然的机会，他和上司出访大客户，终于想起自己原是森林的小导游。偶然得到了一次重新选择人生的机会，为了挽救旧时间线里的熊大熊二，光头强开始了一场奇妙的时空冒险。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20film%20poster%2C%20two%20bears%20in%20a%20colorful%20forest%2C%20playful%20adventure%20theme%2C%20bright%20cheerful%20colors%2C%20animated%20movie%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-07&orientation=portrait",
    director: "林汇达",
    actors: ["谭笑", "张伟", "张秉君"],
    duration: "108分钟",
    views: 1350000,
    isHot: false,
    isNew: true,
    updateEpisode: ""
  },
  {
    id: 8,
    title: "飞驰人生2",
    titleEn: "Pegasus 2",
    category: "电影",
    subCategory: "喜剧",
    year: 2024,
    region: "中国大陆",
    rating: 8.3,
    description: "昔日冠军车手张驰沦为落魄驾校教练，过着靠脸吃饭勉强度日的生活。濒临停产的老头乐车厂厂长主动提出赞助张驰组建车队，再闯最后一届巴音布鲁克拉力赛。面对这泼天的富贵，张驰蠢蠢欲动，召集老朋友们再次踏上赛道。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20film%20poster%2C%20rally%20car%20on%20a%20desert%20track%2C%20dust%20and%20speed%2C%20warm%20sunset%20lighting%2C%20action%20and%20humor%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-08&orientation=portrait",
    director: "韩寒",
    actors: ["沈腾", "范丞丞", "尹正", "张本煜", "孙艺洲"],
    duration: "129分钟",
    views: 2890000,
    isHot: true,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 9,
    title: "消失的她",
    titleEn: "Lost in the Stars",
    category: "电影",
    subCategory: "悬疑",
    year: 2023,
    region: "中国大陆",
    rating: 8.7,
    description: "何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，妻子再次现身，何非却坚持眼前的陌生女人并非妻子。夫妻二人似乎都有不可告人的秘密，随着金牌律师陈麦介入这起离奇案件，更多的谜团慢慢浮现。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mystery%20thriller%20film%20poster%2C%20tropical%20island%20at%20night%2C%20woman%20disappearing%2C%20mysterious%20atmosphere%2C%20dark%20blue%20and%20teal%20tones%2C%20suspenseful%20mood%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-09&orientation=portrait",
    director: "崔睿",
    actors: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    duration: "121分钟",
    views: 3750000,
    isHot: true,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 10,
    title: "八角笼中",
    titleEn: "Octagonal",
    category: "电影",
    subCategory: "剧情",
    year: 2023,
    region: "中国大陆",
    rating: 8.4,
    description: "向腾辉倾注心血想把当地无人照料的孩子培养成才，这让生活本没有出路的孩子们看到了一丝通向未来的曙光。然而随着往日表演视频被爆出，这些残忍血腥的画面刺激了不明真相的人们的神经，一夜之间舆论开始发酵，向腾辉和孩子们都陷入了困境。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20drama%20film%20poster%2C%20young%20fighters%20in%20a%20cage%2C%20mountain%20village%20background%2C%20inspirational%20theme%2C%20warm%20earthy%20tones%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-10&orientation=portrait",
    director: "王宝强",
    actors: ["王宝强", "陈永胜", "史彭元", "王迅"],
    duration: "117分钟",
    views: 2210000,
    isHot: false,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 11,
    title: "庆余年第二季",
    titleEn: "Joy of Life S2",
    category: "电视剧",
    subCategory: "剧情",
    year: 2024,
    region: "中国大陆",
    rating: 9.3,
    description: "范闲从北齐归来后，发现自己已被卷入更深的权力漩涡。庆帝的猜忌、长公主的阴谋、北齐的虎视眈眈，各方势力暗流涌动。范闲在一系列惊心动魄的斗争中逐渐成长，揭开身世之谜的同时，也面临着守护家国和亲友的艰难抉择。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%2C%20ancient%20Chinese%20palace%20setting%2C%20young%20scholar%20in%20traditional%20robes%2C%20dramatic%20lighting%2C%20golden%20and%20red%20tones%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-11&orientation=portrait",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚", "郭麒麟"],
    duration: "",
    views: 5200000,
    isHot: true,
    isNew: false,
    updateEpisode: "全36集"
  },
  {
    id: 12,
    title: "繁花",
    titleEn: "Blossoms Shanghai",
    category: "电视剧",
    subCategory: "剧情",
    year: 2024,
    region: "中国大陆",
    rating: 9.4,
    description: "九十年代的上海，改革开放的春风席卷着这座城市。阿宝凭借自己的智慧和魄力，在商海中沉浮打拼，从默默无闻的普通人一跃成为上海滩的风云人物。黄河路上人来人往，股市里风云变幻，每个人都在为自己的梦想而奋斗。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20street%20scene%2C%20neon%20lights%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20tones%2C%20elegant%20composition%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-12&orientation=portrait",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾", "游本昌"],
    duration: "",
    views: 6800000,
    isHot: true,
    isNew: false,
    updateEpisode: "全30集"
  },
  {
    id: 13,
    title: "狂飙",
    titleEn: "The Knockout",
    category: "电视剧",
    subCategory: "剧情",
    year: 2023,
    region: "中国大陆",
    rating: 9.5,
    description: "京海市一线刑警安欣在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。在全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子，粉碎了黑恶势力的保护伞。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20police%20officer%20in%20dark%20city%2C%20intense%20drama%2C%20noir%20lighting%2C%20dark%20atmosphere%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-13&orientation=portrait",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚", "吴刚"],
    duration: "",
    views: 9100000,
    isHot: true,
    isNew: false,
    updateEpisode: "全39集"
  },
  {
    id: 14,
    title: "三体",
    titleEn: "Three-Body",
    category: "电视剧",
    subCategory: "科幻",
    year: 2023,
    region: "中国大陆",
    rating: 8.9,
    description: "2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。离奇自杀的科学家，近乎神迹的倒计时，行事隐秘的科学边界组织，神秘莫测的网游三体。纳米科学家汪淼被警官史强带到联合作战中心，潜入三体游戏进行调查。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20three%20suns%20in%20alien%20sky%2C%20mysterious%20cosmic%20scene%2C%20dark%20and%20moody%20atmosphere%2C%20intellectual%20sci-fi%20aesthetic%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-14&orientation=portrait",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾", "王子文", "林永健"],
    duration: "",
    views: 4800000,
    isHot: false,
    isNew: false,
    updateEpisode: "全30集"
  },
  {
    id: 15,
    title: "长相思",
    titleEn: "Lost You Forever",
    category: "电视剧",
    subCategory: "爱情",
    year: 2024,
    region: "中国大陆",
    rating: 8.7,
    description: "上古时期，人神妖混居，神农、轩辕、高辛三国鼎立。流落大荒的高辛王姬玖瑶历经百年颠沛流离，失去了身份和容貌，在清水镇落脚成为玟小六。她悬壶济世，恣意不羁，却在命运的安排下，与三位身份各异的男子产生了错综复杂的情感纠葛。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20series%20poster%2C%20ancient%20Chinese%20mythological%20setting%2C%20ethereal%20beauty%2C%20flowing%20silk%20robes%2C%20dreamy%20atmosphere%2C%20soft%20warm%20lighting%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-15&orientation=portrait",
    director: "秦榛",
    actors: ["杨紫", "张晚意", "邓为", "檀健次"],
    duration: "",
    views: 3500000,
    isHot: true,
    isNew: false,
    updateEpisode: "全39集"
  },
  {
    id: 16,
    title: "唐朝诡事录之西行",
    titleEn: "Strange Tales of Tang Dynasty 2",
    category: "电视剧",
    subCategory: "悬疑",
    year: 2024,
    region: "中国大陆",
    rating: 8.6,
    description: "卢凌风与苏无名一同离开长安，踏上西行之路。一路上奇案频发，诡异事件层出不穷。从长安到敦煌，从繁华都市到荒凉大漠，两人凭借超凡的智慧和勇气，破解了一个又一个离奇案件，揭开了一段段尘封的历史谜团。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20TV%20series%20poster%2C%20Tang%20dynasty%20detectives%20in%20desert%2C%20ancient%20Chinese%20atmosphere%2C%20mysterious%20mood%2C%20warm%20earthy%20tones%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-16&orientation=portrait",
    director: "柏杉",
    actors: ["杨旭文", "杨志刚", "郜思雯", "陈创"],
    duration: "",
    views: 2100000,
    isHot: false,
    isNew: true,
    updateEpisode: "更新至28集"
  },
  {
    id: 17,
    title: "与凤行",
    titleEn: "The Legend of Shen Li",
    category: "电视剧",
    subCategory: "爱情",
    year: 2024,
    region: "中国大陆",
    rating: 8.3,
    description: "灵界碧苍王沈璃为掌握自己的命运，在逃婚过程中受伤坠落凡间，被下凡体验生活的上古神君行止所救。两人在凡间共度了一段温馨美好的时光，殊不知命运的齿轮已经悄然转动。当身份揭晓，神魔两界的恩怨情仇也随之浮出水面。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20TV%20series%20poster%2C%20mythical%20phoenix%20and%20dragon%20motif%2C%20ancient%20Chinese%20celestial%20palace%2C%20ethereal%20beauty%2C%20soft%20glowing%20light%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-17&orientation=portrait",
    director: "邓科",
    actors: ["赵丽颖", "林更新", "辛云来", "何与"],
    duration: "",
    views: 3100000,
    isHot: false,
    isNew: true,
    updateEpisode: "全39集"
  },
  {
    id: 18,
    title: "墨雨云间",
    titleEn: "The Double",
    category: "电视剧",
    subCategory: "剧情",
    year: 2024,
    region: "中国大陆",
    rating: 8.4,
    description: "薛芳菲原本是县令之女，过着幸福安稳的生活。一场突如其来的变故夺走了她的一切，她被迫背负罪名，失去至亲。为了洗清冤屈、为家人复仇，薛芳菲踏上了艰难的复仇之路。在这个过程中，她遇到了同样身处困境的肃国公萧蘅，两人携手共渡难关。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20revenge%20drama%20TV%20series%20poster%2C%20determined%20woman%20in%20ancient%20Chinese%20robes%2C%20rainy%20atmosphere%2C%20dramatic%20mood%2C%20dark%20elegant%20tones%2C%20TV%20drama%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-18&orientation=portrait",
    director: "侣皓吉吉",
    actors: ["吴谨言", "王星越", "陈鑫海", "梁永棋"],
    duration: "",
    views: 2650000,
    isHot: false,
    isNew: true,
    updateEpisode: "全40集"
  },
  {
    id: 19,
    title: "奔跑吧·生态篇",
    titleEn: "Keep Running: Eco Season",
    category: "综艺",
    subCategory: "真人秀",
    year: 2024,
    region: "中国大陆",
    rating: 7.8,
    description: "《奔跑吧》全新生态主题季，兄弟团成员将走进中国各地的自然保护区和生态示范区，通过一系列趣味横生的游戏和挑战，向观众展示中国生态文明建设的丰硕成果，传递绿色环保的生活理念。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20in%20nature%2C%20green%20forest%20background%2C%20energetic%20fun%20atmosphere%2C%20bright%20cheerful%20colors%2C%20variety%20show%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-19&orientation=portrait",
    director: "姚译添",
    actors: ["李晨", "郑恺", "沙溢", "白鹿", "周深", "范丞丞", "张真源"],
    duration: "",
    views: 1750000,
    isHot: false,
    isNew: false,
    updateEpisode: "更新至8期"
  },
  {
    id: 20,
    title: "歌手2025",
    titleEn: "Singer 2025",
    category: "综艺",
    subCategory: "音乐",
    year: 2025,
    region: "中国大陆",
    rating: 8.1,
    description: "顶级音乐竞技综艺再度回归，来自华语乐坛的实力唱将齐聚舞台，用音乐点燃激情，用歌声传递感动。全新赛制升级，全开麦真唱不修音，为观众呈现最纯粹的音乐盛宴。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20music%20variety%20show%20poster%2C%20singer%20on%20stage%20with%20dramatic%20spotlight%2C%20concert%20atmosphere%2C%20passionate%20performance%2C%20dark%20background%20with%20golden%20accents%2C%20variety%20show%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-20&orientation=portrait",
    director: "洪啸",
    actors: ["那英", "汪峰", "周深", "华晨宇", "邓紫棋"],
    duration: "",
    views: 4200000,
    isHot: true,
    isNew: false,
    updateEpisode: "更新至12期"
  },
  {
    id: 21,
    title: "咒术回战 第二季",
    titleEn: "Jujutsu Kaisen S2",
    category: "动漫",
    subCategory: "动作",
    year: 2023,
    region: "日本",
    rating: 9.2,
    description: "怀玉篇与涩谷事变篇，讲述了五条悟与夏油杰在高专时期的往事，以及涩谷事件的惊心动魄。咒术界面临前所未有的危机，咒灵们策划了一场大规模袭击，虎杖悠仁和伙伴们必须全力以赴应对这场关乎人类命运的决战。",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%2C%20jujutsu%20sorcerer%20in%20dynamic%20action%20pose%2C%20dark%20supernatural%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20anime%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-21&orientation=portrait",
    director: "御所园翔太",
    actors: ["榎木淳弥", "内田雄马", "濑户麻沙美", "中村悠一"],
    duration: "",
    views: 3800000,
    isHot: true,
    isNew: false,
    updateEpisode: "全23集"
  },
  {
    id: 22,
    title: "间谍过家家 第二季",
    titleEn: "Spy x Family S2",
    category: "动漫",
    subCategory: "喜剧",
    year: 2023,
    region: "日本",
    rating: 9.0,
    description: "为了执行维护东西和平的秘密任务，西国最强间谍黄昏组建起一个临时家庭。妻子约尔是暗杀者，女儿阿尼亚是超能力者，三人各怀秘密却奇妙地组成了一个温馨家庭。第二季中，福杰一家将面临更多挑战与冒险。",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%2C%20spy%20family%20of%20three%20in%20stylish%20outfits%2C%20comedy%20action%20theme%2C%20clean%20elegant%20composition%2C%20warm%20pastel%20colors%2C%20anime%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-22&orientation=portrait",
    director: "古桥一浩",
    actors: ["江口拓也", "种崎敦美", "早见沙织"],
    duration: "",
    views: 2900000,
    isHot: false,
    isNew: false,
    updateEpisode: "全12集"
  },
  {
    id: 23,
    title: "葬送的芙莉莲",
    titleEn: "Frieren: Beyond Journey's End",
    category: "动漫",
    subCategory: "剧情",
    year: 2024,
    region: "日本",
    rating: 9.5,
    description: "魔法使芙莉莲与勇者辛美尔等人历经十年冒险，战胜了魔王，为世界带来了和平。身为精灵的她，在勇者逝世后开始踏上了解人类的旅途。在这段旅程中，她逐渐理解了人类短暂生命中的珍贵情感，也重新认识了与伙伴们的羁绊。",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%2C%20elf%20mage%20in%20a%20fantasy%20landscape%2C%20peaceful%20melancholic%20atmosphere%2C%20soft%20natural%20lighting%2C%20beautiful%20pastoral%20scenery%2C%20anime%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-23&orientation=portrait",
    director: "斋藤圭一郎",
    actors: ["种崎敦美", "市之濑加那", "小林千晃"],
    duration: "",
    views: 4200000,
    isHot: true,
    isNew: false,
    updateEpisode: "全28集"
  },
  {
    id: 24,
    title: "鬼灭之刃 锻刀村篇",
    titleEn: "Demon Slayer: Swordsmith Village",
    category: "动漫",
    subCategory: "动作",
    year: 2023,
    region: "日本",
    rating: 8.8,
    description: "在游郭篇之后，炭治郎前往锻刀村寻求新的日轮刀。在那里，他与霞柱时透无一郎和恋柱甘露寺蜜璃相遇。然而，上弦之鬼的袭击打破了村子的宁静，一场激烈的战斗在所难免。炭治郎必须突破自己的极限，守护锻刀村的匠人们。",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%2C%20demon%20slayer%20with%20sword%20in%20action%2C%20fire%20and%20water%20effects%2C%20traditional%20Japanese%20aesthetic%2C%20intense%20battle%20scene%2C%20anime%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-24&orientation=portrait",
    director: "外崎春雄",
    actors: ["花江夏树", "鬼头明里", "下野纮", "松冈祯丞"],
    duration: "",
    views: 5100000,
    isHot: true,
    isNew: false,
    updateEpisode: "全11集"
  },
  {
    id: 25,
    title: "周处除三害",
    titleEn: "The Pig, The Snake and The Pigeon",
    category: "电影",
    subCategory: "动作",
    year: 2024,
    region: "中国台湾",
    rating: 8.5,
    description: "通缉犯陈桂林在逃亡中得知自己身患绝症，决定在临死前干一件惊天大事。他发现自己只在通缉榜上排名第三，于是决心找到前两名通缉犯并将他们一一除掉。一场黑色荒诞的现代江湖传奇就此展开。",
    imageUrl: "https://readdy.ai/api/search-image?query=Taiwanese%20action%20crime%20film%20poster%2C%20fugitive%20in%20dark%20urban%20setting%2C%20noir%20lighting%2C%20intense%20drama%2C%20dark%20and%20gritty%20atmosphere%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-25&orientation=portrait",
    director: "黄精甫",
    actors: ["阮经天", "袁富华", "陈以文", "王净"],
    duration: "134分钟",
    views: 1680000,
    isHot: false,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 26,
    title: "年会不能停",
    titleEn: "Johnny Keep Walking",
    category: "电影",
    subCategory: "喜剧",
    year: 2024,
    region: "中国大陆",
    rating: 8.7,
    description: "钳工胡建林阴差阳错被调入集团总部，从蓝领变成了白领。在年会上，他这个不懂职场规则的老实人频频闯祸，却也意外揭露了公司内部的种种问题。一场荒诞搞笑的职场冒险就此展开，让人在笑声中思考职场人生。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20film%20poster%2C%20office%20party%20scene%2C%20chaotic%20fun%20atmosphere%2C%20bright%20colorful%20lighting%2C%20humorous%20vibe%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-26&orientation=portrait",
    director: "董润年",
    actors: ["大鹏", "白客", "庄达菲", "王迅", "孙艺洲"],
    duration: "118分钟",
    views: 3100000,
    isHot: false,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 27,
    title: "第二十条",
    titleEn: "Article 20",
    category: "电影",
    subCategory: "剧情",
    year: 2024,
    region: "中国大陆",
    rating: 8.6,
    description: "人到中年的检察官韩明本想努力赶上职业生涯的末班车，却不料卷入了一桩分歧巨大的案件。面对重重困难，他将赌上一切，用自己的方式守护公平与正义。这部聚焦正当防卫的影片，引发了对法律与人性的深刻思考。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20film%20poster%2C%20courtroom%20scene%2C%20serious%20atmosphere%2C%20justice%20theme%2C%20warm%20but%20solemn%20lighting%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-27&orientation=portrait",
    director: "张艺谋",
    actors: ["雷佳音", "马丽", "赵丽颖", "高叶"],
    duration: "141分钟",
    views: 2450000,
    isHot: false,
    isNew: false,
    updateEpisode: ""
  },
  {
    id: 28,
    title: "酱园弄",
    titleEn: "She's Got No Name",
    category: "电影",
    subCategory: "剧情",
    year: 2024,
    region: "中国大陆",
    rating: 8.0,
    description: "1945年的上海酱园弄，发生了一桩轰动全城的凶杀案。作家西林对这起案件产生了浓厚的兴趣，决定深入调查。在探寻真相的过程中，一段尘封的往事被慢慢揭开，而案件的背后，隐藏着令人心碎的故事。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20poster%2C%201940s%20Shanghai%20alley%2C%20mysterious%20woman%2C%20noir%20atmosphere%2C%20period%20costume%2C%20dramatic%20lighting%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-28&orientation=portrait",
    director: "陈可辛",
    actors: ["章子怡", "雷佳音", "王传君", "易烊千玺", "赵丽颖"],
    duration: "135分钟",
    views: 980000,
    isHot: false,
    isNew: true,
    updateEpisode: ""
  },
  {
    id: 29,
    title: "小丑2：双重妄想",
    titleEn: "Joker: Folie à Deux",
    category: "电影",
    subCategory: "剧情",
    year: 2024,
    region: "美国",
    rating: 7.5,
    description: "亚瑟·弗莱克因小丑身份被捕入狱，在阿卡姆精神病院等待审判。在那里他遇到了真爱哈莉·奎茵，两人在疯狂中找到了彼此。音乐与疯狂交织，亚瑟在法庭上为自己的双重人格辩护，一段黑暗而浪漫的故事就此展开。",
    imageUrl: "https://readdy.ai/api/search-image?query=American%20psychological%20thriller%20film%20poster%2C%20joker%20and%20harley%20quinn%20dancing%2C%20dark%20romantic%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20dramatic%20lighting%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-29&orientation=portrait",
    director: "托德·菲利普斯",
    actors: ["华金·菲尼克斯", "Lady Gaga", "布莱丹·格里森"],
    duration: "138分钟",
    views: 1250000,
    isHot: false,
    isNew: true,
    updateEpisode: ""
  },
  {
    id: 30,
    title: "你想活出怎样的人生",
    titleEn: "The Boy and the Heron",
    category: "电影",
    subCategory: "动画",
    year: 2024,
    region: "日本",
    rating: 8.9,
    description: "少年牧真人在母亲去世后随父亲搬到乡下小镇，与继母一起生活。一只会说话的苍鹭的出现，将他带入了一个神秘的塔中世界。在奇幻的冒险中，真人逐渐学会了面对失去和成长，找到了自己人生的答案。",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20animated%20film%20poster%2C%20boy%20and%20mysterious%20heron%20in%20fantasy%20world%2C%20Studio%20Ghibli%20style%2C%20dreamy%20atmosphere%2C%20soft%20natural%20colors%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=800&seq=movie-30&orientation=portrait",
    director: "宫崎骏",
    actors: ["山时聪真", "菅田将晖", "柴咲幸", "木村拓哉"],
    duration: "124分钟",
    views: 1850000,
    isHot: false,
    isNew: false,
    updateEpisode: ""
  }
];

export const categories = [
  { name: "电影", slug: "movie", icon: "ri-movie-2-line" },
  { name: "电视剧", slug: "tv", icon: "ri-tv-2-line" },
  { name: "综艺", slug: "variety", icon: "ri-live-line" },
  { name: "动漫", slug: "anime", icon: "ri-emotion-line" },
];

export const subCategories = [
  { name: "全部", slug: "all" },
  { name: "动作", slug: "action" },
  { name: "喜剧", slug: "comedy" },
  { name: "爱情", slug: "romance" },
  { name: "科幻", slug: "scifi" },
  { name: "恐怖", slug: "horror" },
  { name: "剧情", slug: "drama" },
  { name: "悬疑", slug: "suspense" },
  { name: "动画", slug: "animation" },
  { name: "纪录片", slug: "documentary" },
];

export const categoryMap: Record<string, string> = {
  "movie": "电影",
  "tv": "电视剧",
  "variety": "综艺",
  "anime": "动漫",
};

export const subCategoryMap: Record<string, string> = {
  "all": "全部",
  "action": "动作",
  "comedy": "喜剧",
  "romance": "爱情",
  "scifi": "科幻",
  "horror": "恐怖",
  "drama": "剧情",
  "suspense": "悬疑",
  "animation": "动画",
  "documentary": "纪录片",
};